export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9575.312dd692.jpg";